import type { ReactNode } from "react";
import { Dialog } from "@/components/ui/Dialog";
import { useTimesheetFlowLayers } from "@/features/timesheetFlow/timesheetFlowLayers";

export function BillingAnsweredRowsDialog({
  open,
  onClose,
  count,
  children,
  statusBadge,
  description = "Übersicht aller beantworteten Rückfragen zu diesem Stundennachweis.",
}: {
  open: boolean;
  onClose: () => void;
  count: number;
  children: ReactNode;
  /** Status des Stundennachweises – wird im Titel immer mit angezeigt, wenn gesetzt. */
  statusBadge?: ReactNode;
  description?: ReactNode;
}) {
  const layers = useTimesheetFlowLayers();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <span className="inline-flex flex-wrap items-center gap-2">
          <span>{`Beantwortet (${count})`}</span>
          {statusBadge}
        </span>
      }
      description={description}
      size="2xl"
      zIndexClass={layers.nested}
      fullScreenMobile
      bodyClassName="timesheet-flow-scroll max-h-[min(70vh,720px)] overflow-y-auto max-sm:max-h-none"
    >
      <div className="grid gap-3 lg:grid-cols-2">{children}</div>
    </Dialog>
  );
}
